import React from 'react'
import UserListContainer from './container'
import { useDeleteUserMutation, useGetUserListQuery } from './services';
import { Avatar, Box, Typography } from '@mui/material';
import image from "assests/image.png";
import { VerticalAlignBottom } from '@mui/icons-material';

const UserList = () => {

  const columns = [
    {
      headerName: "Name",
      field: "name",
      sortable: false,
      filterable: false,
      editable: false,
      flex: 1, // Occupies 1 fraction of available space
      minWidth: 150, // Ensures readability on smaller screens
      maxWidth: 300, // Prevents excessively wide columns
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: '100%' }}>
            <Avatar
              alt={row.first_name}
              sx={{
                width: 38,
                height: 38,
                marginRight: "10px",
                textTransform: 'capitalize'
              }}
            >
              {row.first_name ? row.first_name.charAt(0).toUpperCase() : "?"}
            </Avatar>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2" sx={{ color: "text.primary", fontWeight: '500' }}>
                {`${row.first_name} ${row.last_name}` || "N/A"}
              </Typography>
            </Box>
          </Box>
        );
      },
    },    
    {
      headerName: "Username",
      field: "user_name",
      sortable: false,
      filterable: false,
      editable: false,
      flex: 1, // Adjusts proportionally
      minWidth: 150, // Minimum width for smaller screens
      maxWidth: 300, // Prevents overflow on larger screens,
      renderCell: ({ row }) => {
        return (
          <Box className='d-flex align-items-center' sx={{ height: '100%', alignItems: 'center' }}>
            {row?.username}
          </Box>
        )
      }
    },
    {
      headerName: "Phone Number",
      field: "phone_number",
      sortable: false,
      filterable: false,
      editable: false,
      flex: 1, // Equal proportion as other columns
      minWidth: 150,
      maxWidth: 300,
      renderCell: ({ row }) => {
        const number = row?.phone;
        if (!number) {
          return (
            <Box className='d-flex align-items-center' sx={{ height: '100%', alignItems: 'center' }}>
              {"N/A"}
            </Box>
          );
        }

        // Fallback if parsing or formatting fails
        return (
          <Box className='d-flex align-items-center' sx={{ height: '100%', alignItems: 'center' }}>
            {row?.phone}
          </Box>
        );
      },
    },
   
    {
      headerName: "Email",
      field: "email",
      sortable: false,
      filterable: false,
      editable: false,
      flex: 1, // Makes it responsive
      minWidth: 250,
      maxWidth: 450,
      renderCell: ({ row }) => {
        const email = row?.email;
        return (
          <Box className='d-flex' sx={{ alignItems: 'center', height: '100%' }}>
            {email || "N/A"}
          </Box>
        )
      },
    },
  ];


  return (
    <UserListContainer
      columns={columns}
      apiHook={useGetUserListQuery}
      // initialValues={initialValues}
      // formFields={formFields}
      deleteApiHook={useDeleteUserMutation}
      pageId="user-list"
      isViewVisible={false}
      rowHeight={100}
    />
  )
}

export default UserList
